import { inject, Injectable } from '@angular/core';
import { AlertService } from '@td/components/alert/alert.service';
import { type HttpErrorResponse } from '@angular/common/http';
import type { ErrorResponse } from '@td/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class HttpAlertService {
  private readonly alertService = inject(AlertService);
  private readonly transloco = inject(TranslocoService);

  show(response: HttpErrorResponse): void {
    if (response.error instanceof Blob && response.error.type === 'application/json') {
      response.error.text().then((text) => {
        this.showAlertWithResponse(JSON.parse(text));
      });
    } else if (response.status === 0 || !response.error || typeof response.error !== 'object') {
      // timeout or gateway issue
      this.showAlert('errors.http.common.failed-to-get-response');
    } else {
      this.showAlertWithResponse(response.error);
    }
  }

  private showAlertWithResponse(errorResponse: ErrorResponse): void {
    const requestIdText = this.transloco.translate('errors.http.common.request-id');
    const details = [errorResponse.errorMessage || '', `${requestIdText}: ${errorResponse.requestId}`];
    this.showAlert(errorResponse.errorDisplayMessage, details);
  }

  private showAlert(message: string, details?: Array<string>): void {
    this.alertService.open(
      {
        type: 'warning',
        title: 'errors.http.common.request-failed',
        message: message,
        details: details,
      },
      { duration: 15000 },
    );
  }
}
